import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Box, Stack, Typography} from 'views/components';
import {Translate} from 'views/module';

import DomainGuideDetails from './domain_guide_scenes/DomainGuideDetails';
import RawDomainGuide from './domain_guide_scenes/RawDomainGuide';

import {formatCreatedByLabel, isUserRn} from '../utils/createdBy';

import backend from 'utils/backend';

const DomainGuideView = (props) => {
  const {
    domainGuideRn,
    statusProgressWrap: progressWrap,
  } = props;
  const [domainGuideData, setDomainGuideData] = React.useState(null);
  const [domainGuideDataLoaded, setDomainGuideDataLoaded] = React.useState(false);
  const [createdByLabel, setCreatedByLabel] = React.useState('');

  React.useEffect(() => {
    let isActive = true;

    const loadDomainGuide = async () => {
      await progressWrap(async () => {
        const domainGuideResponse = await backend.domainGuide.getDomainGuide(domainGuideRn);
        const domainGuide = domainGuideResponse?.domainGuide || domainGuideResponse || null;
        let nextCreatedByLabel = domainGuide?.createdBy || '';

        if (isUserRn(domainGuide?.createdBy)) {
          try {
            const userResponse = await backend.user.getUser(domainGuide.createdBy, false);

            nextCreatedByLabel = formatCreatedByLabel(userResponse?.user, domainGuide.createdBy);
          } catch {
            nextCreatedByLabel = domainGuide.createdBy;
          }
        }

        if (isActive) {
          setDomainGuideData(domainGuide);
          setCreatedByLabel(nextCreatedByLabel);
          setDomainGuideDataLoaded(true);
        }
      });
    };

    loadDomainGuide();

    return () => {
      isActive = false;
    };
  }, [domainGuideRn, progressWrap]);

  if (!domainGuideDataLoaded) {
    return null;
  }

  if (!domainGuideData) {
    return (
      <Box
        sx={{
          textAlign: 'left',
          width: {
            xs: '100%',
            md: '75%',
          },
        }}
      >
        <Typography
          sx={{
            fontSize: '18px',
            fontWeight: 500,
            color: '#1A1916',
          }}
        >
          <Translate expression='domainGuide.Detail.NotFound' />
        </Typography>
      </Box>
    );
  }

  const updateStatus = (status) => {
    if (!domainGuideData.domainGuideRn || status === domainGuideData.status) {
      return;
    }

    progressWrap(async () => {
      const statusResponse = await backend.domainGuide.updateStatus(domainGuideData.domainGuideRn, status);
      const updatedDomainGuide = statusResponse?.domainGuide || statusResponse || {};

      setDomainGuideData((prevDomainGuideData) => ({
        ...prevDomainGuideData,
        status: updatedDomainGuide.status || status,
      }));
    });
  };

  return (
    <Box
      sx={{
        textAlign: 'left',
        width: {
          xs: '100%',
          md: '75%',
        },
      }}
    >
      <Stack gap={3}>
        <DomainGuideDetails
          createdByLabel={createdByLabel}
          domainGuideData={domainGuideData}
          updateStatus={updateStatus}
        />
        <RawDomainGuide rawDomainGuide={domainGuideData.rawDomainGuide} />
      </Stack>
    </Box>
  );
};

DomainGuideView.propTypes = {
  domainGuideRn: PropTypes.string.isRequired,
  statusProgressWrap: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(React.memo(DomainGuideView));
